<template>
  <div id="app">
    <div id="app-content" class="d-flex flex-column vh-100">
      <NavigationBar :minimized="minimizedNavBar"></NavigationBar>
      <MessageDisplayer class="d-none"></MessageDisplayer>
      <div class="wrapper flex-grow-1 bg-white">
        <router-view/>
      </div>
      <FooterBar></FooterBar>
    </div>
  </div>
</template>

<script>
import NavigationBar from './components/menu/NavigationBar.vue'
import FooterBar from './components/menu/FooterBar.vue'
import MessageDisplayer from './components/menu/MessageDisplayer.vue'

export default {
  name: 'App',
  components: {
    MessageDisplayer,
    NavigationBar,
    FooterBar
  },
  data() {
    return {
      minimizedNavBar: false,
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.onAppScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onAppScroll);
  },
  methods: {
    onAppScroll: function() {
      if (window.scrollY > 20) {
        this.minimizedNavBar = true;
      } else {
        this.minimizedNavBar = false;
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
